import { CallUI } from '@/components/CallUI'
import { Eyebrow } from '@/components/ui/eyebrow'

export const DashboardPage = () => {
  return (
    <div className="h-full flex flex-col">
      <div className="border-b px-6 py-4">
        <Eyebrow>Outbound</Eyebrow>
        {/* The single dashboard-hero gradient accent (1 of the <=2 sparing gradient slots) */}
        <h1 className="text-2xl font-heading font-bold tracking-tight">
          <span className="bg-gradient-to-br from-primary to-[#7C3AED] bg-clip-text text-transparent">
            Dialer
          </span>
        </h1>
        <p className="text-sm text-muted-foreground">
          Make outbound calls to prospects
        </p>
      </div>

      <div className="flex-1 p-6">
        <div className="max-w-2xl">
          <CallUI />
        </div>
      </div>
    </div>
  )
}
